import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { PageHome } from "./routes/page-home";
import { PageInformation } from "./routes/page-info";
import { PageFixRoof } from "./routes/page-fix-roof";
import { PageTv } from "./routes/page-tv";
import { PageFees } from "./routes/page-fees";
import { PageNewcomers } from "./routes/page-newcomers";
import { PageProtocol } from "./routes/page-protocol";
import { PageContact } from "./routes/page-contact";

const router = createBrowserRouter([
  {
    path: "/",
    element: <PageHome />,
  },
  {
    path: "/info",
    element: <PageInformation />,
  },
  {
    path: "/fixa-tak",
    element: <PageFixRoof />,
  },
  {
    path: "/tv",
    element: <PageTv />,
  },
  {
    path: "/avgifter",
    element: <PageFees />,
  },
  {
    path: "/möte",
    element: <PageProtocol />,
  },
  {
    path: "/ny-hos-oss",
    element: <PageNewcomers />,
  },
  {
    path: "/kontakt",
    element: <PageContact />,
  },
]);

const App = () => {
  // useEffect(() => {
  //   document.title = 'Torparängen';
  // }, []);
  return (
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
};

// @ts-ignore
ReactDOM.createRoot(document.getElementById("root")).render(<App />);
